import { DocumentProcess } from './document-process.model';
import { DocumentProcessToLog } from './document-process-to-log.model';
import { ConstancyType } from './enums/constancyType';
import { DocumentProcessToStatus } from './enums/documentProcessToStatusEnum';
export class DocumentProcessTo {
    id: number;
    sintraId: string;
    status: DocumentProcessToStatus = DocumentProcessToStatus.Pending;
    isOrganization: boolean;
    isSignatureupdateDate: boolean;
    idLog: number;
    documentProcessToLog: DocumentProcessToLog;
    constancyType: ConstancyType;
    constancyNumber: string;
    registrationNumber: string;
    documentProcess: DocumentProcess;
    creationDate: Date;
    updateDate: Date;
    firstName: string;
    lastName: string;
    Email: string;
    isSignatory: boolean = false;
    textFlag: string= '';
}

export function DefaultDocumentProcessTo(): DocumentProcessTo {

    let newDocumentProcessTo = new DocumentProcessTo();

    newDocumentProcessTo.firstName = '';
    newDocumentProcessTo.lastName= '';
    newDocumentProcessTo.Email = '';
    newDocumentProcessTo.sintraId = '';
    newDocumentProcessTo.status = DocumentProcessToStatus.Pending;
    newDocumentProcessTo.textFlag = '';
    newDocumentProcessTo.updateDate = new Date();

    return newDocumentProcessTo;
}

